import { render, staticRenderFns } from "./DocumentTab.vue?vue&type=template&id=270afde9&scoped=true"
import script from "./DocumentTab.vue?vue&type=script&lang=js"
export * from "./DocumentTab.vue?vue&type=script&lang=js"
import style0 from "./DocumentTab.vue?vue&type=style&index=0&id=270afde9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270afde9",
  null
  
)

export default component.exports